import { BUSINESS, WA_DEFAULT_MSG } from "@/constants/business";

export default function Navbar() {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-md bg-[var(--tt-cream)]/85 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src="/assets/logo-cropped.jpg"
            alt="Tuncay Ticaret Logo"
            className="w-12 h-12 sm:w-14 sm:h-14 object-contain rounded-xl bg-white shadow-sm border border-black/5"
          />
          <div className="leading-tight">
            <div className="font-display text-lg sm:text-xl text-[var(--tt-green-900)]">
              Tuncay Ticaret
            </div>
            <div className="text-[11px] sm:text-xs uppercase tracking-[0.18em] text-[var(--tt-green-700)] font-semibold">
              Hırdavat & Geri Dönüşüm
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8 text-sm font-semibold text-[var(--tt-charcoal)]/80">
          <a href="#about" className="hover:text-[var(--tt-orange)] transition-colors" data-testid="nav-about">Hakkımızda</a>
          <a href="#services" className="hover:text-[var(--tt-orange)] transition-colors" data-testid="nav-services">Hizmetler</a>
          <a href="#products" className="hover:text-[var(--tt-orange)] transition-colors" data-testid="nav-products">Ürünler</a>
          <a href="#video" className="hover:text-[var(--tt-orange)] transition-colors" data-testid="nav-video">Video</a>
          <a href="#contact" className="hover:text-[var(--tt-orange)] transition-colors" data-testid="nav-contact">İletişim</a>
        </nav>

        <a
          data-testid="nav-cta-whatsapp"
          href={`https://wa.me/${BUSINESS.phones[0].whatsapp}?text=${encodeURIComponent(WA_DEFAULT_MSG)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:inline-flex items-center gap-2 bg-[var(--tt-green-800)] hover:bg-[var(--tt-green-700)] text-white text-sm font-bold rounded-full pl-4 pr-5 py-2.5 transition-colors"
        >
          <svg viewBox="0 0 32 32" className="w-4 h-4 fill-current" aria-hidden="true">
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.788 2.722.788.817 0 2.15-.515 2.45-1.318.158-.43.158-.802.115-.93-.072-.214-.387-.33-.616-.45-.703-.348-1.575-.83-1.875-.83zM16 7.105a8.95 8.95 0 0 0-7.6 13.62L7.2 25l4.4-1.16A8.95 8.95 0 1 0 16 7.105z" />
          </svg>
          Hemen Yaz
        </a>
      </div>
    </header>
  );
}
